/* eslint-disable */
import { CampaignPackageDto, CampaignProductDto, Params, ProductsWithPackages, Voucher } from '@app/interfaces/voucher';
import { onGet, onPost } from './http.api';

export const GetVoucher = async (params: Params): Promise<Voucher> =>
  await onPost<Voucher>(`/Voucher/CheckVoucher`, params);

export const GetToken = async (): Promise<string> => await onGet<string>(`/Voucher/GetToken`);
export const GetCampaignProducts = async (campaignId: string): Promise<CampaignProductDto[]> => {
  // onGet tự append query nếu truyền object
  // nhưng để chắc chắn theo helper hiện tại, cứ truyền object
  const data = await onGet<CampaignProductDto[]>(`/Product/GetCampaignProductsWithPackages`, { id: campaignId });
  return data ?? [];
};

// POST packages theo list productIds
export const GetCampaignPackagesByProducts = async (productIds: string[]): Promise<CampaignPackageDto[]> => {
  const data = await onPost<CampaignPackageDto[]>(`/Package/GetListPackageByProducts`, { productIds });
  return data ?? [];
};
export const GetCampaignProductsWithPackages = async (
  campaignId: string,
  lang: string,
): Promise<ProductsWithPackages> => {
  const data = await onGet<ProductsWithPackages>(`/Product/GetCampaignProductsWithPackages`, {
    id: campaignId,
    lang: lang,
  });
  return data ?? { Products: [], GroupRules: [] };
};
